/** Class name joiner. Small enough that a dependency would be silly. */
export function cx(...parts: unknown[]): string {
  return parts.filter((part) => typeof part === "string" && part !== "").join(" ");
}
